<template>
  <div>
    <div class="py-2 d-flex flex-wrap mx-0" v-if="editing">
      <gear-select
        class="gear-select"
        @change="onParameterChanged"
        :dataKeys="['gear_id']"
        classes="grey"
      />
      <input
        v-model="data.model"
        inputClasses="borderless"
        @change="onParameterChanged"
        class="px-0 mr-2 mt-2 mt-lg-0 ml-lg-3 borderless"
        placeholder="modello"
        :dataKeys="['model']"
        @keydown.enter="onSaveClicked"
      />
      <button
        class="btn btn-link font-weight-semibold text-primary mb-0 my-md-auto mt-auto p-0 ml-3 clickable"
        @click="onSaveClicked"
        :disabled="!valid"
      >
        Aggiungi
      </button>
    </div>
    <div class="py-2 row mx-0 clickable" v-else @click="editing = true">
      <i class="fas fa-plus text-primary my-auto px-0"></i>
      <p
        class="font-weight-semibold text-primary col-4 col-md-3 my-auto px-0 ml-3"
      >
        Aggiungi
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Mixins, Prop, Watch } from "vue-property-decorator";
import InlineEditor from "components/InlineEditor.vue";
import OrdersMixin from "mixins/http/OrdersMixin";
import GearSelect from "components/Gear/Select.vue";
import { RegisterHttp } from "utils/Decorators";
import { RequestData } from "store/types";

@Component({ components: { InlineEditor, GearSelect } })
export default class CreateOrderGearItem extends Mixins(OrdersMixin) {
  static readonly createTag = "create_order_gear";

  @RegisterHttp(CreateOrderGearItem.createTag) createRequestd: RequestData;

  @Prop({ required: true })
  orderId: string;

  private data: any = {};
  private editing: boolean = false;

  get valid() {
    return this.data.gear_id;
  }

  reset() {
    this.data.model = undefined;
    this.data.gear_id = undefined;
  }

  onParameterChanged(value) {
    this.data = {
      order_id: this.orderId,
      ...this.data,
      ...value,
    };
  }

  onSaveClicked() {
    if (!this.valid) {
      return;
    }

    this.createOrderGear(this.data, CreateOrderGearItem.createTag).then(
      (resp) => {
        this.$emit("created", resp);
        this.reset();
        this.editing = false;
      },
    );
  }
}
</script>

<style scoped>
.gear-select {
  width: 250px;
}
</style>
